module.exports = __webpack_public_path__ + "img/14.df4b20a0.svg";